import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smooth-scrolls to `location.hash` when present. React Router v7 doesn't
 * auto-scroll on hash changes, so we do it ourselves. Mounted once at the
 * route root so it covers every navigation.
 */
export function ScrollToHash() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    // Defer one frame so the destination section is mounted (matters when
    // the hash is being followed across a route change).
    requestAnimationFrame(() => {
      try {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      } catch {
        // Invalid selector (rare) — ignore silently.
      }
    });
  }, [hash]);
  return null;
}
